import { render } from "./ProcessBpmModal.vue?vue&type=template&id=6d507a1b&scoped=true"
import script from "./ProcessBpmModal.vue?vue&type=script&lang=js"
export * from "./ProcessBpmModal.vue?vue&type=script&lang=js"

import "./ProcessBpmModal.vue?vue&type=style&index=0&id=6d507a1b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d507a1b"]])

export default __exports__